module.exports = __webpack_public_path__ + "static/media/mobile_credit_card.3d9425d0.svg";